import type Validator from '../../models/Validator';

const PositiveIntegerValidator: Validator = class {
  static isValid(value) {
    if (value) {
      return /^\d+$/.test(value);
    }

    return false;
  }

  static getError() {
    return null;
  }
};

export default PositiveIntegerValidator;

// This is used to suppress characters like 'e, +, -'. Also the 'numeric' field type doesn't enforce type in Safari
// so this is a must have for Safari
// https://jira.hotterpads.com/browse/LEAS-2117
// https://jira.hotterpads.com/browse/LEAS-2113
export function stopPropagationIfInvalidNumber(event) {
  const { keyCode, which } = event;
  const code = typeof which == 'number' ? which : keyCode;
  const START_OF_KEYCODES_TO_IGNORE = 57;
  const START_OF_NUMPAD = 96;
  const END_OF_NUMPAD = 105;
  const SPACE_KEYCODE = 32;

  if (
    (code > START_OF_KEYCODES_TO_IGNORE && (code < START_OF_NUMPAD || code > END_OF_NUMPAD)) ||
    code === SPACE_KEYCODE
  ) {
    event.preventDefault();
    event.stopPropagation();
  }
}
